import { ListingComponentState } from 'types/store/reducers/ui';

import { getIds } from 'store/utils';
import { ClientActions } from 'types/store/actions/clients';
import { ClientActionTypes } from 'types/store/actions/constants';

export const initialState: ListingComponentState = {
  isLoading: false,
  page: 1,
  totalCount: 0,
  hasMore: false,
  ids: [],
};

export default (
  state = initialState,
  action: ClientActions
): ListingComponentState => {
  switch (action.type) {
    case ClientActionTypes.RESET:
      return initialState;

    case ClientActionTypes.LIST_SUCCESS: {
      const { records, perPage, totalCount, page } = action.payload;
      const hasMore = perPage * page < totalCount;
      const ids = getIds(records);

      return {
        ...state,
        ids: [...(page === 1 ? [] : state.ids), ...ids], // If we're on a first page - have to clean all previous ids
        isLoading: hasMore,
        totalCount,
        page,
        hasMore,
      };
    }

    case ClientActionTypes.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    }

    default:
      return state;
  }
};
